import { StakingTierManager } from "@airdao/bond-periphery/core/contracts/types";
import { ContractNames, Contracts } from "@airdao/bond-periphery/core";
import { AddressLike } from "ethers";
import { TierWithLevel } from "./admin";

export async function GetTier(contracts: Contracts, contractName: ContractNames = ContractNames.StakingTierManager, token: AddressLike, user: AddressLike) : Promise<TierWithLevel>{
    const oracle = contracts.getContractByName(contractName) as unknown as StakingTierManager;
    return await oracle.getTier(user, token);
}

export async function GetAllTiers(contracts: Contracts, contractName: ContractNames = ContractNames.StakingTierManager, token: AddressLike) : Promise<TierWithLevel[]>{
    const oracle = contracts.getContractByName(contractName) as unknown as StakingTierManager;
    return await oracle.stakingTiers(token);
}

export async function GetLockContract(contracts: Contracts, contractName: ContractNames = ContractNames.StakingTierManager): Promise<AddressLike>{
    const oracle = contracts.getContractByName(contractName) as unknown as StakingTierManager;
    return await oracle.lock();
}

export async function GetStakedAmount(contracts: Contracts, contractName: ContractNames = ContractNames.StakingTierManager, token: AddressLike, user: AddressLike): Promise<bigint>{
    const oracle = contracts.getContractByName(contractName) as unknown as StakingTierManager;
    return await oracle.getStakedAmount(user, token);
}

export const GetterMethods = {
    GetTier,
    GetAllTiers,
    GetLockContract,
    GetStakedAmount,
};

export default GetterMethods;